import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import uniqid from 'uniqid'
import { Chip, CHIP_SIZE_LG } from '../Chip/Chip'

import './ChipCheckbox.scss'

export const ChipCheckbox = ({
  checked,
  className,
  disabled,
  label,
  onChange,
  name,
  id,
  value,
  'data-mu-test': dataAttributeTest
}) => {
  const inputName = name ? `input-${name}` : uniqid('input-')
  const inputId = id || `${inputName}-${value}`

  return (
    <label
      htmlFor={inputId}
      className={classnames('e-chip-checkbox', className, {
        'e-chip-checkbox--checked': checked,
        'e-chip-checkbox--disabled': disabled
      })}
    >
      <input
        type='checkbox'
        checked={checked}
        name={inputName}
        id={inputId}
        value={value}
        onChange={onChange}
        disabled={disabled}
      />
      <Chip
        size={CHIP_SIZE_LG}
        label={label}
        data-mu-test={dataAttributeTest}
      />
    </label>
  )
}

ChipCheckbox.propTypes = {
  checked: PropTypes.bool,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  id: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
  /**
   * Additional values for data-attribute used for tests and tracking
   **/
  'data-mu-test': PropTypes.string
}
